export default __webpack_public_path__ + "static/media/waiting-room.810bb645.jpg";